import Blue from "~/dfwjobs/core";

new Blue({
	name: 'FAQ Accordion',
	selector: ".faqs__accordion",
	setup(accordion) {
    const items = [...accordion.querySelectorAll('.faqs__item')];
    const relations = [];

    items.forEach(container => {
      let trigger = container.querySelector('.faqs__trigger')
      let content = container.querySelector('.faqs__content')
      let config = {
        container,
        trigger,
        content,
        relations
      }
      relations.push(new this.$toggle(config));
    })
	}
});